import $ from 'jquery'

export function initialise() {
  $(document).on('change', '[data-table-sortable-filter]', (event) => {
    const id = $(event.currentTarget).attr('data-table-sortable-filter')
    const $table = $('#' + id)

    const filters = $('select')
      .get()
      .map((el) => {
        const val = $(el).val()
        if (!val) return
        return { name: el.name, value: val }
      })
      .filter(Boolean)

    $table.find('tbody tr').each((_i, tr) => {
      let show = true
      filters.forEach(({ name, value }) => {
        const val = $(tr).find(`[data-name="${name}"]`).attr('data-value')
        if (val !== '' && val.indexOf(value) === -1) {
          show = false
        }
      })
      tr.hidden = !show
    })
  })
}
